<template>
  <v-dialog :value="true" :width="width" :persistent="persistent" @input="dismiss">
    <v-card>
      <template v-if="title">
        <v-card-title v-html="title" />
        <v-divider />
      </template>
      <template v-if="msg">
        <v-card-text class="pt-4 break-word" v-html="msg" />
        <v-divider />
      </template>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          v-for="btn in buttons" :key="btn"
          text
          :loading="!!loadTimeout"
          :color="btn == primary ? 'primary' : null"
          @click="resolve(btn)"
        >
          {{btn}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String },
    msg: { type: String },
    buttons: { type: Array, default: () => [ 'No', 'Yes' ] },
    primary: { type: String, default: 'Yes' },
    width: { type: Number, default: 300 },
    persistent: { type: Boolean, default: true },
    loading: { type: Number, default: 0 },
    resolve: { type: Function }
  },

  data() {
    return { loadTimeout: null };
  },

  mounted () {
    document.addEventListener('keyup', this.onKeyUp);
    if (this.loading)
      this.loadTimeout = setTimeout(() => this.loadTimeout = null, this.loading);
  },

  destroyed () {
    document.removeEventListener('keyup', this.onKeyUp);
    if (this.loadTimeout)
      clearTimeout(this.loadTimeout);
  },

  methods: {
    dismiss() {
      this.resolve(this.primary);
    },

    onKeyUp(e) {
      if (!this.loadTimeout && (e.keyCode == 13) && (this.buttons.indexOf(this.primary) != -1)) {
        e.stopPropagation();
        this.resolve(this.primary);
      }
    }
  }
}
</script>
